// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"EU12_TheComp__VARtk"};